export default {
      id: "tags-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#tags",
      toString: function () {
        return this.url;
      }
    }